import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import ProcessManager from '../../../Common/Managers/ProcessManager';

const BotonEditar = (props) => {
    return (
        <div className="dropdown">
            <Link to={ProcessManager.GetNextStep("ConfiguracionSesionVista", "ROUTE_TO_CONFIGSESIONVISTA_EDIT")}>
                <button type="submit" className="btn btn-cta" title="Editar">
                    Editar
                </button>
            </Link>
        </div>
    );
}

export default BotonEditar